var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.withdrawComponent,{tag:"component",attrs:{"shared":_vm.shared,"common":_vm.commonContext},on:{"toggle-mode":_vm.displayCryptoChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }